var map = {
	"./ITS-Databases.pdf": 969,
	"./ITS-Python.pdf": 1051,
	"./TQC-Python-ML.jpg": 645,
	"./TQC-Python-WebScraping.jpg": 651,
	"./cert-toeic.jpg": 729,
	"./google-marketing.pdf": 9740,
	"./螢幕擷取畫面 2025-11-25 050412.png": 9265,
	"./螢幕擷取畫面 2025-11-25 050454.png": 3579,
	"./螢幕擷取畫面 2025-11-25 050604.png": 6542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9603;